export enum FeatureToggle {
  HPP_STRENSIQ = "hpp-strensiq",
  HPP_STRENSIQ_REDIRECT = "hpp-strensiq-redirect",
  ASTHMA = "asthma",
  LIVER_TRANSPLANT = "liver-transplant",

  APPEAL_HUB_REFERRAL_FLOW_V2 = "appeal-hub-referral-flow-v2",

  DISABLE_LETTER_ISSUE_EMAILS = "disable-letter-issue-emails",

  ENHANCED_APPEAL_STATUS = "enhanced-appeal-status",

  EMAIL_INSURER = "email-insurer",
}
